import React, {Component} from 'react';
import {connect} from 'react-redux';
import DepartmentScores from "./departmentScores";
import * as actions from "../../actions";
import {toJS} from "../hocs/toJs";
import _ from 'lodash';

class DepartmentScoresHOC extends Component {

  componentDidMount(){
    if(this.props.match.params.id){
      this.props.getDepartmentById({id:this.props.match.params.id});

      this.props.getScoreRecords({
        filter: {
          include: [{relation: 'scores'}],
          where: {departmentId: this.props.match.params.id}
        }
      });

      this.props.getStores({});

      this.props.getCriteria({filter: {
          where: {and: [
              {departmentId: this.props.match.params.id},
              {or: [{deleted: false}, {deleted: null}]}
            ]}
        }
      });
    }
  }

  _getPendingStoresToScore = () => {

    return this.props.stores.filter(store => {
      const storeUnScoredCriteria = this._getStoreUnScoredCriteria(store);
      return !!storeUnScoredCriteria.length;
    }).map(store => {
      const storeUnScoredCriteria = this._getStoreUnScoredCriteria(store);
      const storeTotalCriteria = this._getTotalStoreCriteria(store);
      return {
        ...store,
        totalScoredCriteria: storeTotalCriteria - storeUnScoredCriteria.length
      }
    });

  };

  _getStoreUnScoredCriteria = (store) => {

    const scores = this.props.scoreRecords.reduce((acc, next) => {
      return [...acc, ...next.scores]
    }, []);

    let weightType;
    if(store.new) { weightType = 'weightNew'}
    if(store.newComing) { weightType = 'weightNewComing'}
    if(store.old) { weightType = 'weightOld'}

    let storeScoredCriteria = scores
      .filter(score => { return score.storeId === store.id && score.scoreValue > 0 } )
      .map(item => item.criteriaId);

    storeScoredCriteria = _.uniq(storeScoredCriteria);

    return this.props.criteria.filter(criterion => {

      return !storeScoredCriteria.includes(criterion.id) && criterion[weightType] > 0

    });

  };

  _getTotalStoreCriteria = (store) => {

    let weightType;
    if(store.new) { weightType = 'weightNew'}
    if(store.newComing) { weightType = 'weightNewComing'}
    if(store.old) { weightType = 'weightOld'}

    const storeCriteria = _.filter(this.props.criteria, criterion => {return criterion[weightType] > 0});

    return storeCriteria.length

  };

  render(){
    return (
      <DepartmentScores
        {...this.props}
        pendingStoresToScore={this._getPendingStoresToScore()}
        _getStoreUnScoredCriteria={this._getStoreUnScoredCriteria}
        _getTotalStoreCriteria={this._getTotalStoreCriteria}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    department: state.department.get('department'),
    criteria: state.criteria.get('criteria'),
    scoreRecords: state.scoreRecords.get('scoreRecords'),
    stores: state.stores.get('stores'),
    fetchingStores: state.stores.get('fetching'),
    fetchingScoreRecords: state.scoreRecords.get('fetching')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDepartmentById: (payload) => {
      dispatch(actions.getDepartmentById(payload))
    },
    getScoreRecords: (payload) => {
      dispatch(actions.getScoreRecords(payload))
    },
    getCriteria: (payload) => {
      dispatch(actions.getCriteria(payload))
    },
    getStores: (payload) => {
      dispatch(actions.getStores(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(DepartmentScoresHOC));



// WEBPACK FOOTER //
// ./src/components/department/departmentScoresHOC.js